export const getPortraitItemImage = (imageId: string = "") => {
  const { sourcesUrl } = useRuntimeConfig().public;
  if (imageId === "tokenGFAL")
    return `${sourcesUrl}/marketplace/images/${imageId}.webp`;

  if (!imageId) {
    return `${sourcesUrl}/marketplace/images/notFound_portrait.webp`;
  } else {
    return `${sourcesUrl}/marketplace/${imageId}_portrait.webp`;
  }
};

export const getLargeItemImage = (imageId: string = "") => {
  const { sourcesUrl } = useRuntimeConfig().public;
  if (!imageId) return `${sourcesUrl}/marketplace/images/notFound_large.webp`;
  else return `${sourcesUrl}/marketplace/${imageId}_large.webp`;
};

export const getAvatar = (imageId: string | null = "") => {
  const { sourcesUrl } = useRuntimeConfig().public;
  if (!imageId) {
    return `${sourcesUrl}/marketplace/images/avatars/DEFAULT.webp`;
  } else {
    return `${sourcesUrl}/marketplace/images/avatars/${imageId.toLocaleUpperCase()}.webp`;
  }
};

export const getUserBanner = (imageId: string | null = "") => {
  const { sourcesUrl } = useRuntimeConfig().public;
  if (!imageId) return `${sourcesUrl}/marketplace/images/banners/banner0.webp`;
  else return `${sourcesUrl}/marketplace/images/banners/${imageId}.webp`;
};

export const getUserBannerSmall = (imageId: string = "") => {
  const { sourcesUrl } = useRuntimeConfig().public;
  if (!imageId)
    return `${sourcesUrl}/marketplace/images/banners/banner0_small.webp`;
  else return `${sourcesUrl}/marketplace/images/banners/${imageId}_small.webp`;
};

export const getGameIcon = (merchantId: string) => {
  const { sourcesUrl } = useRuntimeConfig().public;
  if (!merchantId) return `${sourcesUrl}/marketplace/images/default_icon.png`;
  else return `${sourcesUrl}/marketplace/${merchantId}/icon.webp`;
};

export const getGameThumbnail = (merchantId: string) => {
  const { sourcesUrl } = useRuntimeConfig().public;
  if (!merchantId)
    return `${sourcesUrl}/marketplace/images/default_thumbnail.webp`;
  else return `${sourcesUrl}/marketplace/${merchantId}/thumbnail.webp`;
};

export const getGameBanner = (merchantId: string) => {
  const { sourcesUrl } = useRuntimeConfig().public;
  if (!merchantId)
    return `${sourcesUrl}/marketplace/images/default_banner.webp`;
  else return `${sourcesUrl}/marketplace/${merchantId}/banner.webp`;
};

export const checkImageExists = async (
  imageId: string,
  format: string = "webp"
): Promise<boolean> => {
  const { sourcesUrl } = useRuntimeConfig().public;
  const url = `${sourcesUrl}/marketplace/${imageId}.${format}`;
  try {
    const response = await fetch(url, { method: "HEAD" });
    if (response.status === 404) {
      return false;
    }
    return response.ok;
  } catch (error) {
    return false;
  }
};

export const getDeviceIcon = (type: string | undefined) => {
  if (typeof type !== "string") return "mdi:devices";
  switch (type) {
    case "console":
      return "mdi:gamepad-variant-outline";
    case "desktop":
      return "mdi:computer";
    case "smartphone":
      return "mdi:cellphone";
    case "tablet":
      return "mdi:tablet-android";
    case "tv":
      return "mdi:tv";
    case "wearable":
      return "mdi:watch-variant";
    case "car browser":
      return "mdi:car";
    default:
      return "mdi:devices";
  }
};
